import { useMemo } from 'react';

export const useMinDateToValue = (dateFrom: Date | null) => {
    const minDateTo = useMemo(() => (dateFrom ? new Date(dateFrom) : undefined), [dateFrom]);

    return minDateTo;
};
